import { render, staticRenderFns } from "./SubjectSpecial.vue?vue&type=template&id=6761484f&scoped=true&"
import script from "./SubjectSpecial.vue?vue&type=script&lang=js&"
export * from "./SubjectSpecial.vue?vue&type=script&lang=js&"
import style0 from "./SubjectSpecial.vue?vue&type=style&index=0&id=6761484f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6761484f",
  null
  
)

export default component.exports